function MusterTerms() {
  return (
    <div style={{ maxWidth: "680px", margin: "0 auto", padding: "2rem 1rem", lineHeight: "1.6", overflowY: "scroll", height: "100vh" }}>
      <h1 style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px" }}>Muster</h1>
      <hr style={{ marginTop: "20px", marginBottom: "20px" }} />
      <h1>Muster Terms and Conditions</h1>
      <p><em>Last updated: March 25, 2025</em></p>

      <p>
        These Terms and Conditions govern your use of Muster, a text message-based service for
        communicating with volunteers about events. By opting in to receive messages from Muster,
        you agree to these terms.
      </p>

      <h2>The Service</h2>
      <p>
        Muster allows organizations to send and receive text messages with volunteers for the purpose
        of coordinating events. This includes reminders, scheduling updates, and operational communications.
        Muster is not intended for emergency notifications or time-critical safety communications.
      </p>

      <h2>Eligibility</h2>
      <p>
        You must be at least 13 years old to use Muster. By using the service, you represent that
        you are the authorized user of the phone number you provide.
      </p>

      <h2>Consent to Receive Messages</h2>
      <p>
        By opting in, you consent to receive recurring automated text messages from Muster related
        to volunteer events. Message frequency varies. Standard message and data rates may apply
        depending on your carrier and plan. Consent is not a condition of participating in any
        volunteer program or event.
      </p>

      <h2>Opting Out</h2>
      <p>
        You may opt out at any time by replying <strong>STOP</strong> to any message. You will
        receive a final confirmation and no further messages will be sent. To re-enroll, reply{" "}
        <strong>START</strong>. For help, reply <strong>HELP</strong>.
      </p>

      <h2>Acceptable Use</h2>
      <p>You agree not to use Muster to:</p>
      <ul>
        <li>Send or respond with harassing, abusive, or unlawful content.</li>
        <li>Impersonate another person or organization.</li>
        <li>Interfere with the operation of the service.</li>
        <li>Attempt to gain unauthorized access to any part of the system.</li>
      </ul>
      <p>
        We reserve the right to remove any user from the service for violations of these terms.
      </p>

      <h2>Disclaimer of Warranties</h2>
      <p>
        Muster is provided "as is" without warranties of any kind. We do not guarantee that the
        service will be uninterrupted, error-free, or that messages will be delivered at any
        particular time. SMS delivery is subject to carrier availability and conditions outside
        our control.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, Muster and its operators shall not be liable for
        any indirect, incidental, or consequential damages arising from your use of the service,
        including missed messages, delayed communications, or reliance on information received
        via text message.
      </p>

      <h2>Third-Party Services</h2>
      <p>
        Muster uses third-party providers including Twilio for SMS delivery and OpenAI and/or
        Anthropic for message parsing. Your use of Muster is subject to their respective terms
        of service in addition to these terms.
      </p>

      <h2>Changes to These Terms</h2>
      <p>
        We may update these terms from time to time. The date at the top of this page reflects
        the most recent revision. Continued use of the service after changes constitutes
        acceptance of the updated terms.
      </p>

      <h2>Governing Law</h2>
      <p>
        These terms are governed by the laws of the United States. Any disputes arising from
        use of the service will be resolved in the appropriate courts of jurisdiction.
      </p>

      <h2>Contact</h2>
      <p>
        For questions about these terms, contact:{" "}
        <a href="mailto:privacy@sethduncan.com">privacy@sethduncan.com</a>
      </p>
    </div>
  );
}

export default MusterTerms;
